<template>
  <div class="homePage">
    <Header></Header>
    <router-view class="midContainer" :style="route.path === '/homePage' ? { paddingTop: '0px'} : { paddingTop: '72px' }"></router-view>
    <Footer :platInfo="platInfo"></Footer>
    <floatingWidget  :platInfo="platInfo"  v-if="configFloatShow"></floatingWidget>
  </div>
</template>
<script>
import { ref, getCurrentInstance, onMounted, computed } from "vue";
import Header from "@/components/headers/header.vue";
import Footer from "@/components/footers/footers.vue";
import { useRoute } from "vue-router";
export default {
  name: "homePage",
  components: { Header,Footer },
  setup() {
    const { proxy } = getCurrentInstance();
    const route = useRoute();
    const height = ref(document.documentElement.clientHeight);
    const platInfo = ref({})
    // 监听浏览器尺寸变化
    onMounted(() => {
      
      window.addEventListener("resize", () => {
        // 监听页面尺寸变化
        // console.log(document.documentElement.clientHeight);
        height.value = document.documentElement.clientHeight;
      });
      
    });
    const getPortalInfo = () => {
      proxy
        .$request({
          url: "PROTAL_N_INDUSTRYMANGE_FINDDEFAULTBYTYPE",
          data: {
            portalType: "nfstzx"
          },
          method: "post",
        })
        .then((res) => {
          if (res.data.code == "000") {
            let result = res.data.result;
            // changeFavicon(proxy.commenUrl + result.browserIcon);
            document.title = result.browserName;
            platInfo.value.tradeImg = res.data.result.tradeImg
            platInfo.value.gzh = res.data.result.gzh
            platInfo.value.tel = res.data.result.tel

          }


          // store.commit("setTheme", result.theme);
          // store.commit("setModule", result.module);

        })
        .catch((err) => {
          console.log(err);
        });
    };
    getPortalInfo()
    
    const floatShow = ref(proxy.getConfig().floatShow)
    const configFloatShow = computed(() => {
      return floatShow.value;
    });
    return {
      route,
      height,
      getPortalInfo,
      platInfo,
      configFloatShow
    };
  },
};
</script>
<style scoped lang="less">
.homePage {
  // overflow: hidden;
  .midContainer {
    min-height: 600px;
  }
}
</style>
